export const COMPANY = {
  nameFull: "United Building Maintenance and Residential Cleaning Services",
  nameShort: "United Building Maintenance",
  abbr: "UBM",
  phoneDisplay: "(479) 215-9086",
  phoneLink: "tel:+14792159086",
  email: "Alymanlvw@gmail.com",
  emailLink: "mailto:Alymanlvw@gmail.com",
  region: "Northwest Arkansas",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 3:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  owners: "Beth & Ken Lyman",
};

export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_401496cd-0a55-4d26-9a47-e1aff1c8910d/artifacts/qnesbgbl_IMG_0016.webp";

export const IMAGES = {
  lobby:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_401496cd-0a55-4d26-9a47-e1aff1c8910d/artifacts/ncynyt0c_27D085C8-4E85-4319-82C8-E005F730F443.png",
  commercialFloor:
    "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwamFuaXRvcmlhbCUyMHRlYW18ZW58MHx8fHwxNzg0NTk3NjU1fDA&ixlib=rb-4.1.0&q=85",
  commercialTeam:
    "https://images.pexels.com/photos/9462636/pexels-photo-9462636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  officeInterior:
    "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1OTc2NTV8MA&ixlib=rb-4.1.0&q=85",
  residential:
    "https://images.pexels.com/photos/6195277/pexels-photo-6195277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  residentialInterior:
    "https://images.pexels.com/photos/28586197/pexels-photo-28586197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  officeBuilding:
    "https://images.unsplash.com/photo-1730404691983-cc26f90b4f46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1OTc2NTV8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_CITIES = [
  "Siloam Springs", "Bentonville", "Rogers", "Fayetteville", "Springdale",
  "Bella Vista", "Centerton", "Cave Springs", "Gravette", "Decatur",
  "Tontitown", "Prairie Grove", "Farmington",
];

export const COMMERCIAL_SERVICES = [
  { title: "Office Cleaning", desc: "Daily and scheduled cleaning that keeps workspaces sharp and professional." },
  { title: "Commercial Janitorial", desc: "Complete janitorial programs tailored to your facility and staff." },
  { title: "Restroom Cleaning & Sanitation", desc: "Thorough disinfection and restocking for spotless, hygienic restrooms." },
  { title: "Trash Removal", desc: "Reliable collection and disposal across your entire property." },
  { title: "Floor Care", desc: "Strip, wax, buff, and maintenance for hard floors and carpet." },
  { title: "Vacuuming & Mopping", desc: "Consistent detailed floor care throughout every area." },
  { title: "Breakroom Cleaning", desc: "Sanitized surfaces, appliances, and dining areas for your team." },
  { title: "Common-Area Cleaning", desc: "Lobbies, hallways, and shared spaces kept guest-ready." },
  { title: "Window & Glass Cleaning", desc: "Streak-free interior glass, partitions, and entry doors." },
  { title: "Recurring Cleaning Plans", desc: "Daily, weekly, or monthly programs built around your schedule." },
  { title: "Custom Cleaning Schedules", desc: "Flexible plans designed for your building and budget." },
  { title: "Move-In & Move-Out Cleaning", desc: "Turnover cleaning for tenants and property transitions." },
  { title: "Post-Construction Cleanup", desc: "Detailed debris and dust removal for new or renovated spaces." },
];

export const FACILITY_TYPES = [
  "Office", "Medical Facility", "Church", "Retail Space", "Warehouse",
  "Property Management", "Restaurant", "School", "Other",
];

export const FREQUENCIES = [
  "One-time", "Daily", "Weekly", "Bi-weekly", "Monthly", "Custom",
];

export const TESTIMONIALS = [
  { name: "Property Manager, Bentonville", text: "United Building Maintenance has been incredibly consistent. Our offices look spotless every single morning, and communication is always professional.", rating: 5 },
  { name: "Homeowner, Fayetteville", text: "Booking online was so easy, and the deep clean exceeded our expectations. Beth and Ken's team is trustworthy and detail-oriented.", rating: 5 },
  { name: "Clinic Administrator, Rogers", text: "Sanitation is critical in our medical office. UBM understands our standards and never cuts corners. Highly recommended.", rating: 5 },
];

export const FAQS = [
  { q: "What areas do you serve?", a: "We proudly serve Northwest Arkansas, including Siloam Springs, Bentonville, Rogers, Fayetteville, Springdale, Bella Vista, Centerton, Cave Springs, Gravette, Decatur, Tontitown, Prairie Grove, and Farmington." },
  { q: "Do you offer both commercial and residential cleaning?", a: "Yes. We provide commercial janitorial and building maintenance for businesses, as well as recurring, deep, move-in/out, and one-time residential cleaning for homeowners." },
  { q: "How do I get a commercial quote?", a: "Use our Request a Quote form on the Commercial Cleaning page. We'll review your facility details and follow up with a custom cleaning plan and pricing." },
  { q: "How does residential booking work?", a: "Choose your service, pick an available date and time, tell us about your home, add any extras, and pay securely online. You'll receive an instant confirmation email." },
  { q: "Are your cleaners insured and reliable?", a: "Absolutely. We are locally operated and committed to dependable, consistent cleaning with careful attention to detail." },
  { q: "What is your cancellation policy?", a: "We ask for at least 48 hours' notice to reschedule or cancel a residential appointment. See our Cancellation Policy for details." },
];
